/** Google Maps / Business Profile links — update here when listings change. */
export const PAKKARENT_LOCATIONS = [
  {
    id: 'chennai',
    city: 'Chennai',
    accent: '#FF6B00',
    branches: [
      {
        name: 'Velachery',
        hint: 'Main showroom',
        mapUrl: 'https://share.google/NKPINmnonZHBhwIa9',
      },
      {
        name: 'Kelambakkam',
        hint: 'Second branch',
        mapUrl: 'https://share.google/fL0OUyPdeRwusKv7e',
      },
    ],
    listings: [
      { label: 'Chennai Rental', mapUrl: 'https://share.google/NpspuqfGODUSxuVmQ' },
      { label: 'Event Rental', mapUrl: 'https://share.google/qR3MevI8qWtVrGc1C' },
    ],
  },
  {
    id: 'bangalore',
    city: 'Bangalore',
    accent: '#2196F3',
    branches: [
      {
        name: 'Bangalore Rental',
        hint: 'Doorstep delivery hub',
        mapUrl: 'https://share.google/Dd7wmB7zxiNdZbRhX',
      },
    ],
    listings: [],
  },
  {
    id: 'hyderabad',
    city: 'Hyderabad',
    accent: '#43A047',
    branches: [
      {
        name: 'PakkaRent Hyderabad',
        hint: 'Full rental catalogue',
        mapUrl: 'https://share.google/XsncpNlcyX3Tbezzb',
      },
    ],
    listings: [],
  },
];
